export const PagesGroup = {
  home: "/home",
  reports: "/reports",
  balances: "/balances",
  payin: "/payin-management",
  payout: "/payout-management",
  merchantManagement: "/merchant-management",
  gatewayManagement: "/gateway-management",
  gatewayRouting: "/gateway-management/routing",
  beneficiaryAccounts: "/beneficiary-accounts",
  manualTransactions: "/manual-transactions",
  customers: "/customers",
  blacklist: "/blacklist",
  userManagement: "/user-management",
  withdrawals: "/withdrawals",
  overdraftFacility: "/overdraft-facility",
  status: "/status",
  maintenance: "/maintenance",
  custodians: "/custodians",
  operatorTopUp: "/operator-topups",
  monitoring: "/monitoring",
} as const;

export type PagesGroupKeys = keyof typeof PagesGroup;
export type PagesGroupType = (typeof PagesGroup)[PagesGroupKeys];

export const Pages = {
  login: "/login",
  ssoCallback: "/login/sso-callback",
  reports: "/reports",
  balances: "/balances",
  balancesMerchant: "/balances/merchant",
  monitoring: "/monitoring",
  monitoringSuccessRate: "/monitoring/success-rate",
  monitoringMoneyOut: "/monitoring/money-out",
  balancesGateway: "/balances/gateway",
  balancesCustodian: "/balances/custodian",
  blacklist: "/blacklist",
  blacklistByType: "/blacklist/:type",
  merchantLedger: "/balances/merchant/:id/:currency",
  gatewayLedger: "/balances/gateway/:id/:pgaId/:currency",
  gatewayBalanceReconciliations:
    "/balances/gateway/gateway-balance-reconciliations",
  custodianLedger: "/balances/custodian/:id/:currency",
  manualTransactions: "/manual-transactions",
  manualTransactionsDetail: "/manual-transactions/:id",
  manualTransactionBalanceTransfer: "/manual-transactions/balance-transfer",
  manualTransactionBalanceTransferDetail:
    "/manual-transactions/balance-transfer/:id",
  manualTransactionBatchBalanceTransferDetail:
    "/manual-transactions/balance-transfer/batch/:id",
  manualTransactionBalanceUpdate: "/manual-transactions/balance-update",
  manualTransactionBalanceUpdateDetail:
    "/manual-transactions/balance-update/:id",
  payins: "/payin-management/payins",
  payinDetail: "/payin-management/payins/:id",
  payinsCredit: "/payin-management/payins-credit",
  payinCreditDetail: "/payin-management/payins-credit/:id",
  payout: "/payout-management/payouts",
  payoutDetail: "/payout-management/payouts/:id",
  settlements: "/settlements",
  settlementDetail: "/settlements/:id",
  merchants: "/merchant-management/merchants",
  merchantDetail: "/merchant-management/merchants/:id/:tabId",
  merchantUsers: "/merchant-management/merchant-users",
  merchantGroupings: "/merchant-management/merchant-groupings",
  merchantGroupingsDetail: "/merchant-management/merchant-groupings/:id",
  gateway: "/gateway-management/gateways",
  gatewayDetail: "/gateway-management/gateways/:id/:tabId",
  gatewayMaintenance: "/gateway-management/gateway-maintenance",
  gatewayRouting: "/gateway-management/routing",
  gatewayRoutingRules: "/gateway-management/routing/rules",
  gatewayRoutingRulesTransactionType:
    "/gateway-management/routing/rules/:transactionType",
  gatewayRoutingConstraint: "/gateway-management/routing/constraint",
  beneficiaryAccounts: "/beneficiary-accounts/accounts",
  beneficiaryAccountsDetail: "/beneficiary-accounts/accounts/:id",
  customers: "/customers",
  userManagement: "/user-management/users",
  merchantUserManagement: "/user-management/merchant-users",
  withdrawals: "/withdrawals",
  withdrawalsDetail: "/withdrawals/:id",
  overdraftFacility: "/overdraft-facility",
  status: "/status",
  systemStatus: "/status/system",
  paymentChannelStatus: "/status/payment-channel",
  paymentChannelStatusLevel: "/status/payment-channel/:level",
  paymentChannelMerchantStatus: "/status/payment-channel/merchant/:id",
  maintenanceOneTime: "/status/maintenance/one-time",
  maintenanceOneTimeDetail: "/status/maintenance/one-time/:id",
  maintenanceRecurring: "/status/maintenance/recurring",
  maintenanceRecurringDetail: "/status/maintenance/recurring/:id",
  custodians: "/custodians",
  custodiansDetail: "/custodians/:id/:tabId",
  merchantTopups: "/merchant-topups",
  merchantTopupsDetail: "/merchant-topups/:id",
  operatorTopups: "/operator-topups",
  operatorTopupsDetail: "/operator-topups/:id",
} as const;

export type PagesKeys = keyof typeof Pages;
export type PagesType = (typeof Pages)[PagesKeys];

export const isOneOfPage = (currentPage: string, ...pageTypes: PagesType[]) =>
  pageTypes.some((pageType) => currentPage === pageType);
